import { createApi } from "@reduxjs/toolkit/query/react";
import qs from "qs";

import {
    IGetInviteTherapistLinkQuery,
    IGetInviteTherapistLinkResponse,
    IGetInviteTherapistLinksByClientQuery,
    IGetInviteTherapistLinksByClientResponse,
    IGetInviteTherapistLinksQuery,
    IGetInviteTherapistLinksResponse,
    IRegisterInvitedTherapistBody,
    IRegisterInvitedTherapistResponse,
} from "../../types/inviteTherapists";
import { withGlobalFilter, withPagination } from "../../utils/queries";
import { baseQueryWithIntercept } from "../connection/api";

const ENDPOINT_PREFIX = "invite-therapists";

export const inviteTherapistsApi = createApi({
    reducerPath: "inviteTherapistsApi",
    baseQuery: baseQueryWithIntercept,
    tagTypes: ["inviteTherapists"],
    endpoints: build => ({
        getInviteTherapistLink: build.query<IGetInviteTherapistLinkResponse, IGetInviteTherapistLinkQuery>({
            query: data => ({
                url: `${ENDPOINT_PREFIX}/${data.token}`,
                method: "GET",
            }),
            providesTags: ["inviteTherapists"],
        }),
        registerInvitedTherapist: build.mutation<IRegisterInvitedTherapistResponse, IRegisterInvitedTherapistBody>({
            query: data => ({
                url: `${ENDPOINT_PREFIX}/${data.token}/register`,
                method: "POST",
                body: data.data,
            }),
            invalidatesTags: ["inviteTherapists"],
        }),
        getInviteTherapistLinks: build.query<IGetInviteTherapistLinksResponse, IGetInviteTherapistLinksQuery>({
            query: data => ({
                url: `${ENDPOINT_PREFIX}?${qs.stringify({
                    ...withPagination(data.pageIndex, data.pageSize),
                    ...withGlobalFilter(data.globalFilter ?? ""),
                    ...(data.status !== undefined && { status: data.status }),
                })}`,
                method: "GET",
            }),
            providesTags: ["inviteTherapists"],
        }),
        deleteInviteTherapistLink: build.mutation<{ message: string }, { id: string }>({
            query: data => ({
                url: `${ENDPOINT_PREFIX}/${data.id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["inviteTherapists"],
        }),
        getInviteTherapistLinksByClient: build.query<IGetInviteTherapistLinksByClientResponse, IGetInviteTherapistLinksByClientQuery>({
            query: data => ({
                url: `${ENDPOINT_PREFIX}/by-client/${data.clientId}`,
                method: "GET",
            }),
            providesTags: ["inviteTherapists"],
        }),
    }),
});

export const {
    useGetInviteTherapistLinkQuery,
    useRegisterInvitedTherapistMutation,
    useGetInviteTherapistLinksQuery,
    useDeleteInviteTherapistLinkMutation,
    useGetInviteTherapistLinksByClientQuery,
} = inviteTherapistsApi;
